import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "bit-popover-header",
  templateUrl: "./popover-header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverHeaderComponent {}
